/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

function replaceKlarnaWithImage() {
  const elements = document.querySelectorAll(':not(.page-content):not(.gif-meta) > p');
  const klarnaRegex = /Klarna/g;

  elements.forEach(element => {
    const originalText = element.textContent;

    if (originalText.match(klarnaRegex)) {
      const newText = originalText.replace(klarnaRegex, `<img src="https://cdn.shopify.com/s/files/1/0633/1718/0585/files/klarna.png?v=1707929195" alt="Klarna" class="klarna-icon" />`);
      element.innerHTML = newText; 
    }
  });
}

replaceKlarnaWithImage(); 


//   if(document.querySelectorAll('.c_shop_others.wfinline > .other_group').length > 4) {
//         var scrollTimer = -1;
    
//         var var_ele = document.querySelector('.c_shop_others.wfinline');
//             var_ele.insertAdjacentHTML('afterBegin', `<button class="product-list__arrow prev-next-button prev-next-button--next">
//                     <span class="visually-hidden">Next</span><svg focusable="false" width="17" height="14" class="icon icon--nav-arrow-right  icon--direction-aware " viewBox="0 0 17 14">
//         <path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="2" fill="none"></path>
//       </svg></button>`);
//       var_ele.addEventListener("scroll", throttleScroll(function(){
//               if (scrollTimer != -1)
//         clearTimeout(scrollTimer);
//         scrollTimer = window.setTimeout("scrollFinishedZ()", 200);
//   var s_left = var_ele.scrollLeft;
//     if(s_left <= 0) {
// document.querySelector('.more-var-button').style.display = 'block';
//     } else {
//       document.querySelector('.more-var-button').style.display = 'none';
//     }                                                 
//   }, 10));

//     var more_vars_button = document.querySelector('.more-var-button');
// more_vars_button.addEventListener("click", function() {
//   document.querySelector('.c_shop_others.wfinline').scrollLeft = 4000;
// });
//   }

function scrollToReviews() {
const reviewSlides = document.querySelector('.review-slides');
  const productTabs = document.querySelector('.product-tabs__content');

if (reviewSlides) {
  const pc_button = document.querySelector('tabs-nav > scrollable-content > div > div > button:nth-child(3)');
  const mobile_button = reviewSlides.parentElement.parentElement.previousElementSibling;
  if (mobile_button && mobile_button.getAttribute('aria-expanded') === 'false') {
    mobile_button.click();
  }

  if(pc_button) {
    pc_button.click();
  } 
  productTabs.scrollIntoView({
    behavior: 'smooth',
    block: 'center'
  });
}
  }


const splideElement = document.querySelector('.splide');
if(splideElement){
var splide = new Splide( '.splide', {
  type   : 'loop',
  padding: '4rem',
} );

splide.mount();
}

setTimeout(function () {
  var hero_text = document.querySelectorAll("split-lines > span")[1];
if(hero_text.innerText.includes('ZOMER') || hero_text.innerText.includes('SUMMER')) {
hero_text.parentNode.insertAdjacentHTML('beforeend', `<small style="
    font-size: 25px;
">Tot 60% korting</small>`);

} else if(hero_text.innerText.includes('Sommerverkauf')) {
hero_text.parentNode.insertAdjacentHTML('beforeend', `<small style="
    font-size: 25px;
">BIS ZU 60% RABATT</small>`);

}
}, 200);